<template>
    <div :class="{ 'form-group': true, row: horizontal }">
        <label :for="name" :class="computedLabelClass" v-if="label">{{ label }}</label>
        <div :class="controlClass">
            <slot/>
            <slot name="description"><p class="my-1" v-if="description">{{description}}</p></slot>
            <validation :validation="validation" v-if="validation"/>
            <slot name="after"/>
        </div>
    </div>
</template>

<script>
    import widget from '../../mixins/widget';

    export default {
        mixins: [widget],

        computed: {
            computedLabelClass: vm => ({
                'col-form-label': vm.horizontal,
                'col-12 col-sm-3 col-xl-2 text-left text-sm-right': vm.horizontal,
                [vm.labelClass]: !!vm.labelClass,
                // 'font-weight-normal': !vm.required,
                // 'font-weight-bold': vm.required,
            }),

            controlClass() {
                if (!this.horizontal) {
                    return '';
                }

                return {
                    'col-12 col-sm-9 col-xl-7': true,
                    'offset-sm-3 offset-xl-2': !this.label,
                };
            },
        },
    };
</script>
